import { WidgetDefinition } from '../models/WidgetDefinition';

export const doughnutChartWidgetDefinition: WidgetDefinition = {
    // Check in widgetFactory.ts if type is correct
    // also check editWidget.service.ts and dashboardSeries.services.ts to see if serie bound is configured
    baseType: 'DoughnutChart',
    group: 'Charts',
    hasImage: true,
    highlights: ['Doughnut or pie chart', 'Use this chart to show proportions of a whole'],
    icon: 'fa-pie-chart',
    sortingOrder: 500,
    title: 'Doughnut chart',
    type: 'DoughnutChart'
};